import {LoadPhotoswipe} from './load-photoswipe';

const settings = {
  templateIndex: 0,
};

const selectors = {
  buttonQuickView: '[data-button-quick-view]',
  cartDrawer: '[data-cart-drawer]',
};

const classes = {
  loading: 'is-loading',
  quickViewFromCart: 'js-quick-view-from-cart',
  mainClass: 'popup-quick-view pswp--not-close-btn',
};

const attributes = {
  handle: 'data-handle',
  variantId: 'data-variant-id',
};

const options = {
  history: false,
  focus: false,
  mainClass: classes.mainClass,
  showHideOpacity: false, // we need that off to control the animation ourselves
  closeOnVerticalDrag: false,
  closeOnScroll: false,
  modal: false,
  escKey: false,
};

class QuickViewPopup {
  constructor(container) {
    this.container = container;

    const buttons = this.container.querySelectorAll(selectors.buttonQuickView);
    buttons.forEach((button) => {
      button.addEventListener('click', (e) => this.initPhotoswipe(e));
      button.addEventListener('theme:popup:init', () => {
        button.classList.remove(classes.loading);
      });
    });
  }

  initPhotoswipe(e) {
    e.preventDefault();

    const button = e.target.matches(selectors.buttonQuickView) ? e.target : e.target.closest(selectors.buttonQuickView);
    let quickViewVariant = '';

    button.classList.add(classes.loading);

    // Add class js-quick-view-from-cart to change the default Quick view animation
    if (button.closest(selectors.cartDrawer)) {
      document.body.classList.add(classes.quickViewFromCart);
    }

    // Set the trigger element before calling trapFocus
    slate.a11y.state.trigger = button;

    if (button.hasAttribute(attributes.variantId)) {
      quickViewVariant = `&variant=${button.getAttribute(attributes.variantId)}`;
    }

    const productUrl = `${theme.routes.root}products/${button.getAttribute(attributes.handle)}?section_id=api-quickview${quickViewVariant}`;

    fetch(productUrl)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        const items = [
          {
            html: data,
          },
        ];
        new LoadPhotoswipe(items, options, settings.templateIndex, button);
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  }
}

export default QuickViewPopup;
